import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, of} from "rxjs";
import { CountriesActions } from "./countries.actions";
import { CountryService } from "app/services";

@Injectable()
export class CountriesEffects {
  constructor(
    private actions$: Actions,
    private countryService:CountryService
  ) {}

  loadCountriesWhenInit$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CountriesActions.getCountries),
      mergeMap(() =>
        this.countryService.get().pipe(
          map((countries) => CountriesActions.setCountries({ countries })),
          catchError(() => of(CountriesActions.setCountries({ countries: [] })))
        )
      )
    )
  });
}
